/// <amd-module name="Wit/Common/TeamSettingsPanel/Contracts/Contracts" />
import { IObservableValue } from "VSS/Core/Observable";
import { MessageCardSeverity } from "VSSUI/MessageCard";

export interface ITeamPanelSettings {
    backlogVisibilitySettings: IBacklogVisibilitySetting[];
    workingDays: IWorkingDay[];
    bugsBehavior: IObservableValue<string>;
    isBugsBehaviorValid: boolean;
}

export interface IBacklogVisibilitySetting {
    id: string;
    name: string;
    color: string;
    checked: IObservableValue<boolean>;
    isRequirementmentBacklog?: boolean;
}

export interface ITeamPermissions {
    CurrentUserHasTeamPermission: boolean;
    CurrentUserHasTeamAdminPermission: boolean;
}

export interface IWorkingDay {
    isWorkday: IObservableValue<boolean>;
    name: string;
    id: number;
}
